import { usePlanRoot } from "lib/use-plan-root"
import { useState } from "react"
import { schedulesOutOfDate } from "routes/asset-register/plugins/schedules-out-of-date/controller/schedules-out-of-date"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import { Box, Container, List } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { PageSize } from "lib/@components/pagination/page-size"
import { RequestPageRepeat } from "lib/@components/request-page-repeat"
import { OutOfDateSchedule } from "routes/asset-register/plugins/schedules-out-of-date/out-of-date-schedule"
import { SearchBoxUsingSearchParam } from "lib/@components/searchBoxUsingSearchParam"
import { useSearchParam } from "lib/@hooks/use-search-param"
import { PaginationPortal } from "lib/@components/pagination-portal"
import { FitInRemainingSpace } from "lib/@components/fit-in-remaining-space"

const dummy = { items: [], total: 0 }

export function UpdatedSFG20() {
    const planRoot = usePlanRoot()
    const [take, setTake] = useState(10)
    const [skip, setSkip] = useState(0)
    const [search] = useSearchParam("search")
    const { items, total } = schedulesOutOfDate.useResults({ regimeId: planRoot?.id, skip, take, search }) ?? dummy

    return items === dummy.items ? (
        <LoadingScreen />
    ) : (
        <Container>
            <ListItemBox>
                <Box flex={1}>
                    <SearchBoxUsingSearchParam placeholder="Search by title, code or where the schedule is located" />
                </Box>
                <PageSize setTake={setTake} take={take} />
                <PaginationPortal />
            </ListItemBox>
            <FitInRemainingSpace Component={List} leaveSpace={24} data-cy="regime-schedule-library-updates-ul">
                <RequestPageRepeat
                    total={total}
                    list={items}
                    setSkip={setSkip}
                    setTake={setTake}
                    pageSize={take}
                    item={<OutOfDateSchedule />}
                />
            </FitInRemainingSpace>
        </Container>
    )
}
